__turbopack_context__.v({
  "virtualize": "index-module-scss-module__h_lXMG__virtualize",
});
